import User from "./views/user";
import Personal from "./personal";
import Delivery from "./views/delivery";
import Entity from "./views/entity";

export const personal = () => {
  const personalContainerElement = document.querySelector(`.js-personal`);

  if (personalContainerElement) {
    const userContainer = personalContainerElement.querySelector(`.js-personal-user`);
    const deliveryContainer = personalContainerElement.querySelector(`.js-personal-delivery`);
    const entityContainer = personalContainerElement.querySelector(`.js-personal-entity`);

    const userItemView = new User(userContainer);
    const deliveryItemView = new Delivery(deliveryContainer);
    const entityItemView = new Entity(entityContainer);

    const personal = new Personal(userItemView, deliveryItemView, entityItemView);
    personal.init();
  }
};
